import { Footer } from '@/previewThemes/editorial/Footer';
import { Header } from '@/previewThemes/editorial/Header';
import { Product } from '@/previewThemes/editorial/Product';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  listing: {
    grid: 'grid-cols-2 gap-10 xl:grid-cols-3',
    filters: 'sidebar',
    columns: 3,
    // A magazine's shelf is a photograph with a caption, not a boxed tile.
    card: 'airy',
  },
  // Space instead of rules: this theme separates with air, so its panels are
  // unboxed and the gutters carry the structure.
  cart: { grid: 'mt-12 grid gap-16 lg:grid-cols-3', panel: 'bare' },
  checkout: {
    grid: 'mt-12 grid items-start gap-16 lg:grid-cols-[minmax(0,1fr)_22rem]',
    panel: 'bare',
  },
  search: {
    grid: 'mt-12 grid gap-14 lg:grid-cols-[240px_1fr]',
    results: 'grid grid-cols-2 gap-10 lg:grid-cols-3',
    columns: 3,
    card: 'airy',
  },
  blog: { list: 'grid max-w-3xl gap-14', title: 'text-3xl' },
  category: { grid: 'grid gap-10 sm:grid-cols-2 lg:grid-cols-3', tile: 'bare' },
  // What this theme used to write on `BuyBox` and `ProductGallery` by hand.
  // The merchant's components read it wherever they have left a setting at
  // "the theme's own", which is where every shop starts - so a shop nobody
  // has arranged renders the product page this theme has always drawn.
  parts: {
    product_details: {
      presentation: {
        classes: { product_title: 'text-4xl' },
        gallery: { aspect: 'portrait' },
      },
    },
  },
};
